// TODO: findout imported commented packages and refactor the component

import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from "@material-ui/core/TableRow";
import TableCell from '@material-ui/core/TableCell';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Box from "@material-ui/core/Box";
import moment from 'moment'

import { ATTRIBUTE } from "../../../constants/attributes";
import { PROFILE_TYPE } from "../../../constants/profiles";


const styles = {
    scheduleRow: {
        backgroundColor: '#F2F2F2',
    },
    scheduleCell: {
        border: '1px solid #FFF',
        '&:not(:nth-child(4n+1)):not(:nth-child(4n+0))': {
        }
    },
    activitiesContainer: {
        padding: '0 !important',
    },
    activitiesRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: "white",
        }
    },
    activitiesCell: {
        textAlign: 'center',
        minWidth: '150px',
        backgroundColor: '#F8F8F8',
        border: '2px solid #FFF',
    }
};

const MDCRow = (props) => {
    //TODO: profile, index, status props
    const { classes, row, lov, language, attribute } = props;
    const [open, setOpen] = useState(false);
    const [tooltipOpen, setTooltipState] = useState(null);

    const calculateDuration = (ms) => {
        let tempTime = moment.duration(ms);
        let hours = tempTime.hours();
        let minutes = tempTime.minutes();
        return hours === 0 ? minutes + `min` : hours + `h` + `:` + minutes + `m`;
    }

    const toggleTextToClipboard = (e, index) => {
        navigator.clipboard.writeText(e.target.dataset.value);
        setTooltipState(tooltipOpen === index ? null : index);
    }

    return (
        <>
            <TableRow className={classes.scheduleRow}>
                <TableCell className={classes.scheduleCell} colSpan={12}>
                    <div style={{ display: 'inherit', position: 'sticky', left: '15px' }}>
                        <span>
                            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </span>
                        <span>{row.name.en !== '' ? row.name.en : 'schedule unnamed'} - </span>
                        <span>{moment.utc(row.occurrences[0].when).format('DD/MM/YYYY h:mmA')}</span>
                        <span> - Schedule ID: {row.id}</span> {/* TODO: REMOVE : TESTING */}
                    </div>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell className={classes.activitiesContainer} colSpan={12}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="schedules">
                                <TableBody>
                                    {row.occurrences[0]?.events.map((activityRow, index) => (
                                        <TableRow className={classes.activitiesRow} key={activityRow.id}>
                                            <Tooltip
                                                title={'copied to clipboard'}
                                                open={tooltipOpen === index}
                                                disableFocusListener
                                                disableHoverListener>
                                                <TableCell
                                                    style={{ cursor: 'pointer' }}
                                                    className={classes.activitiesCell}
                                                    data-value={activityRow.id}
                                                    onClick={(e) => toggleTextToClipboard(e, index)}
                                                    onMouseLeave={() => setTooltipState(null)}>{activityRow.id.split('-')[0]}</TableCell>
                                            </Tooltip>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.type.name.en}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.status.name.en}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {calculateDuration(activityRow.duration)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.tolerance_min?.before === activityRow.tolerance_min?.after ? `+/- ${activityRow.tolerance_min.before}min` : `${activityRow.tolerance_min.before}min / ${activityRow.tolerance_min.after}min`}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.attributes?.map((attr) => attr.id === ATTRIBUTE.PO_NUMBER ? attr.value : null)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {row.occurrences[0].attributes?.map((attr) => attr.id === ATTRIBUTE.CARRIER_NAME && lov !== undefined ? lov[attr.id].find((item) => item.id === attr.value)[`name_${language}`] : null)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.profiles?.map((profile) => profile.profile?.type?.id === PROFILE_TYPE.HUMAN ? profile.profile?.firstname + ' ' + profile.profile?.lastname : null)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.profiles?.map((profile) => profile.profile?.type?.id === PROFILE_TYPE.VEHICLE ? profile.profile?.name : null)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.profiles?.map((profile) => profile.profile?.type?.id === PROFILE_TYPE.TRAILER || profile.profile?.type?.id === PROFILE_TYPE.CONTAINER ? profile.profile?.name : null)}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.zones ? activityRow.zones.map((zone) => zone.zone?.name) : null}
                                            </TableCell>
                                            <TableCell className={classes.activitiesCell}>
                                                {activityRow.instructions ? activityRow.instructions[0].instruction[`${language}`] : null}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        language: state.user.language,
        profiles: state.profiles,
    };
};

export default connect(mapStateToProps)(withRouter(withStyles(styles)(MDCRow)));